  const config = {
    API_BASE_URL: '/api',
  };

 /* const config = {
    API_BASE_URL: 'http://localhost:8082',
 };*/

 /*const config = {
  API_BASE_URL: 'http://192.168.0.141:8082',
};*/

  /*const config = {
    API_BASE_URL: 'http://192.168.0.200:8080',
  };*/

  /*const config = {
    API_BASE_URL: 'http://vps61036.publiccloud.com.br:8082',
  };*/

 /*const config = {
    API_BASE_URL: 'http://10.30.128.162:8082',
  };*/
  
  export default config;
